import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbToastrService
} from '@nebular/theme';
import { Subject, takeUntil } from 'rxjs';
import { BatchJobService } from 'src/app/core/services/batch-job.service';
import { CampaignWebSocketService } from 'src/app/core/services/web-socket.service';

@Component({
  selector: 'app-campaign-terminate-modal',
  templateUrl: './campaign-terminate-modal.component.html',
  styleUrls: ['./campaign-terminate-modal.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class CampaignTerminateModalComponent implements OnDestroy {
  private unsubscribe = new Subject<void>();

  public campaign_id?: string;
  public batch_job_id?: string;
  public reason = '';

  constructor(
    protected ref: NbDialogRef<CampaignTerminateModalComponent>,
    private service: BatchJobService,
    private socketService: CampaignWebSocketService,
    private toastr: NbToastrService
  ) {}

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public terminate() {
    if (this.batch_job_id) {
      this.service
        .terminateJob(this.batch_job_id, this.reason)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data.message === 'successful') {
            this.socketService.closeWindow(data.job_id);
            this.ref.close(true);
          }
        });
    } else {
      this.toastr.danger('', $localize`No Batch Job ID provided.`);
    }
  }

  public close() {
    this.ref.close(false);
  }
}
